import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Proveedor } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
      KeyEventUtil.leaveOnKeyEvent('input-titulo')
    })
  }

  const clickClear = () => {
    values._idSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.tipoDocumentoSocio = ''
    values.nombreSocio = ''

    setValues(values)
  }

  const onCreate = (socioCreado, closeModal) => {
    values._idSocio = socioCreado._id
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.nombreSocio = socioCreado.razonSocial
    values.tipoDocumentoSocio = socioCreado.tipoDocumento

    setValues(values)
    closeModal()
    KeyEventUtil.leaveOnKeyEvent('input-titulo')
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='PROVEEDOR' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup
              id='input-codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
            />
          ) : (
            <Select2Proveedor
              disabled={fIsSubmitting}
              id='codigoRucSelect'
              onChange={onChangeSocioHandler}
              showNewButton
              onCreate={onCreate}
            />
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
